import moment from 'moment-timezone'
import { useCallback } from 'react'
import slugify from 'slugify'

import yup from 'civic-champs-shared/utils/yup'
import { useCurrentOrg } from 'auth/hooks'
import { OpportunityApiResponse } from 'Event/interfaces'

export interface SuperEventMember {
  opportunityId: number
  date: string
}

export interface SuperEvent {
  id?: number
  title: string
  description: string
  link?: string
  startsAt?: moment.MomentInput
  endsAt?: moment.MomentInput
  //TODO this is ...clumsy, but having /organizations/:orgId/super_events/:id NOT return occurrences is even stranger
  events: SuperEventMember[] | OpportunityApiResponse[]
}

export const useGetSuperEventLink = () => {
  const organization = useCurrentOrg()

  return useCallback(
    ({ link, title }: SuperEvent): string => {
      const slug = slugify(title, { strict: true, lower: true, trim: true })
      return `${process.env.REACT_APP_EVENTS_SITE_ENDPOINT}/organizations/${organization.id}/pages/${link}/${slug}`
    },
    [organization.id],
  )
}

export const superEventSchema = yup.object({
  title: yup.string().trim().required(),
  description: yup.string().required(),
  events: yup
    .array()
    .of(
      yup.object({
        opportunityId: yup.number().required(),
        date: yup.string().required(), //TODO date format YYYY-MM-DD
      }),
    )
    .min(1)
    .required(),
})
